import { PROFILE } from "./types";

export const getProfileDetails = () => ({
  type: PROFILE.GET_PROFILE_DETAILS
})

export const getProfileDetailsSuccess = (response) => ({
  type: PROFILE.GET_PROFILE_DETAILS_SUCCESS,
  response
})

export const getProfileDetailsFailure = (error) => ({
  type: PROFILE.GET_PROFILE_DETAILS_FAILURE,
  error
})

export const getLanguageDetails = () => ({
  type: PROFILE.GET_LANGUAGE_DETAILS
})

export const getLanguageDetailsSuccess = (response) => ({
  type: PROFILE.GET_LANGUAGE_DETAILS_SUCCESS,
  response
})

export const getLanguageDetailsFailure = (error) => ({
  type: PROFILE.GET_LANGUAGE_DETAILS_FAILURE,
  error
})
export const getJobDetails = (language) => ({
  type: PROFILE.GET_JOB_DETAILS,
  language
})

export const getJobDetailsSuccess = (response) => ({
  type: PROFILE.GET_JOB_DETAILS_SUCCESS,
  response
})

export const getJobDetailsFailure = (error) => ({
  type: PROFILE.GET_JOB_DETAILS_FAILURE,
  error
})
export const getDepartmentsDetails = (language) => ({
  type: PROFILE.GET_DEPARTMENT_DETAILS,
  language
})

export const getDepartmentsDetailsSuccess = (response) => ({
  type: PROFILE.GET_DEPARTMENT_DETAILS_SUCCESS,
  response
})

export const getDepartmentsDetailsFailure = (error) => ({
  type: PROFILE.GET_DEPARTMENT_DETAILS_FAILURE,
  error
})

export const updateProfileDetails = (request) => ({
  type: PROFILE.UPDATE_PROFILE_DETAILS,
  request
})

export const updateProfileDetailsSuccess = (response) => ({
  type: PROFILE.UPDATE_PROFILE_DETAILS_SUCCESS,
  response
})

export const updateProfileDetailsFailure = (error) => ({
  type: PROFILE.UPDATE_PROFILE_DETAILS_FAILURE,
  error
})

export const updateFieldValue = (fieldValue) => ({
  type: PROFILE.UPDATE_FIELD_VALUE,
  fieldValue
})

export const updateError = (errorValue) => ({
  type: PROFILE.UPDATE_ERROR,
  errorValue
})

export const displayToast = (val) => ({
  type: PROFILE.DISPLAY_TOAST,
  val
})
export const displayNativeToast = (val) => ({
  type: PROFILE.DISPLAY_NATIVE_TOAST,
  val
})

export const resetValues = () => ({
  type: PROFILE.RESET_VALUES
})